import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend'; // Carga de archivos JSON

/**
 * i18next configuration
 * DOCS: https://react.i18next.com/getting-started
 */
i18n
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: 'es', // Forzar español por defecto - Disable if using a language detector
        supportedLngs: ['es', 'en', 'eu'], // Add your supported languages here
        fallbackLng: 'es', // Idioma por defecto
        detection: {
            order: ['htmlTag', 'cookie'],
            caches: ['cookie'],
        }, // orden en el que intenta detectar el idioma
        // debug: true, // Habilita logs en desarrollo
        interpolation: {
            escapeValue: false, // React ya escapa las variables
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json', // Ruta de archivos de traducción (desde public)
            queryStringParams: { v: window.translationsVersion || Date.now() }
        },
        // carga las traducciones sin utilizar Suspense, no bloquea la interfaz 
        react: {
            useSuspense: false,
        },
    });

export default i18n;